import React, { Component } from 'react';

class Product extends Component {
	

    processFilters(filters){

        var strClasses = 'productTile ';
        for ( let a = 0; a < filters.length; a++ ) {
            strClasses += filters[a].class+' ';
        }
        return strClasses;

    }
  	render() {
        let {title,link,filters,thumb} = this.props.product; // ,roles

        thumb = process.env.REACT_APP_PUBLIC_URL + thumb;
        //link = process.env.REACT_APP_PUBLIC_URL + link;

        let category = this.props.category;
        let hasLink = true;
        let strProductClass = '';
        if(link.length===0){
            hasLink=false;
        }

        if(category.filters.length===0){
            strProductClass = 'product';
        }
        else{
            strProductClass = 'product hidden';
        }

        //console.log('roles: ', roles);
        

  		return (

            <div className={strProductClass}>
            {hasLink ? (
                    <a className={this.processFilters(filters)} href={link} target="_blank" rel="noreferrer"> 
                        <div className="product-content">
                            <div className="productThumb">
                                    <img className="thumb" src={thumb} alt="thumb"/>
                            </div>
                            <div className="productTitle">
                                {title}
                            </div>

                        </div>
                    </a>
            ):(
                <div className={this.processFilters(filters)}> 
                        <div className="product-content">
                            <div className="productThumb">
                                    <img className="thumb" src={thumb} alt="thumb"/>
                            </div>
                            <div className="productTitle">
                                {title}
                            </div>

                        </div>
                    </div>
            )}
          </div>
          
  		)
  	}
}

export default Product;
